
const r = /dy_height=(\d+)/;

export const getArticleImageHeight = (str: string) => {
  const s = str.match(r);
  return s ? `${s[1]}em` : 'auto';
};
